const Notes = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      d="M14.0039 7.42004V12.5C14.0039 13.2956 13.6879 14.0587 13.1252 14.6213C12.5626 15.1839 11.7996 15.5 11.0039 15.5H1.00391V2.5H9.22388"
      stroke="#0466B4"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8953 4.06793L12.4524 1.63166L13.3935 0.693181C13.5207 0.569379 13.6914 0.5 13.8691 0.5C14.0468 0.5 14.2174 0.569379 14.3446 0.693181L15.8064 2.15087C15.9306 2.2777 16 2.44788 16 2.62511C16 2.80234 15.9306 2.97252 15.8064 3.09935L14.8953 4.06793Z"
      fill="#0466B4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.91717 11.0371L5.30411 11.4963C5.2631 11.5033 5.22092 11.5004 5.18128 11.4878C5.14165 11.4752 5.10572 11.4532 5.0763 11.4239C5.04689 11.3946 5.02488 11.3587 5.01226 11.3192C4.99964 11.2797 4.99672 11.2376 5.00371 11.1967L5.46421 8.59079L7.91717 11.0371Z"
      fill="#0466B4"
    />
    <path
      d="M11.7559 2.15418L6.16931 7.72361L8.61133 10.1598L14.198 4.59038L11.7559 2.15418Z"
      fill="#0466B4"
    />
  </svg>
);

export default Notes;
